/*
 * @Author: lishiqiao
 * @Date: 2022-01-17 17:20:29
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-21 09:57:38
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:24:32
     * @description: 产量--查询顶级机构下的所有机构
     * @param {*} rootId 顶级机构id
     */
    getOutPutCompanyList(rootId) {
        const url = `/desktopReport/queryRewardtOrgFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:26:25
     * @description: 产量--查询顶级机构下的所有造次
     * @param {*} rootId
     */
    getOutPutPeriodList(rootId) {
        const url = `/desktopReport/queryRewardtPerioyFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:28:21
     * @description: 产量--查询顶级机构下的所有品类
     * @param {*} rootId
     */
    getOutputBreedTypeList(rootId) {
        const url = `/desktopReport/queryRewardtTypeFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:29:45
     * @description: 产量--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getOutPutBreedList(rootId) {
        // const url = `/desktopReport/queryRewardtBreedFish/${rootId}`;
        const url = `/desktopReport/queryRewardBreed/fish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:39:42
     * @description: 塘口收获情况--查询顶级机构下的所有养殖场
     * @param {*} params
     */
    getPondBaseList(params) {
        const url = `/desktopReport/queryBoxOrg`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:41:12
     * @description: 塘口收获情况--查询顶级机构下的所有造次
     * @param {*} params
     */
    getPondPeriodList(params) {
        const url = `/desktopReport/queryBoxBatch`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:44:17
     * @description: 塘口收获情况--查询顶级机构下的所有品类
     * @param {*} params
     */
    getPondBreedTypeList(params) {
        const url = `/desktopReport/queryBoxType`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:46:36
     * @description: 塘口收获情况--查询顶级机构下的所有品种
     * @param {*} params
     */
    getPondBreedList(params) {
        const url = `/desktopReport/queryBoxBreed`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:48:46
     * @description: 收获概览-产量报表-养成分页
     * @param {*} params
     */
    getOutPutPageList(params) {
        const url = `/outHarvestDailyOrg/searchOutHarvestDailyOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:49:54
     * @description: 收获概览-产量报表分页-养成分页导出
     * @param {*} params
     */
    exportOutPutData(params) {
        const url = `/outHarvestDailyOrg/exportOutHarvestDailyOrgList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:51:14
     * @description: 收获概览-塘口收获情况-（养成、育苗）分页
     * @param {*} params
     */
    getPondPageList(params) {
        const url = `/mdtPondHarvest/searchMdtPondHarvestList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 17:51:53
     * @description: 收获概览-塘口收获情况-（养成、育苗）分页导出
     * @param {*} params
     */
    exportPondData(params) {
        const url = `/mdtPondHarvest/exportMdtPondHarvestList`;
        return Page.exportDatas(url, params)
    },
}